import { useWorkerTypesContext } from "@/pages/configurations/workerTypes/context/WorkerTypesContext";
import { Button, Grid } from "@material-ui/core";
import { GridColDef } from "@material-ui/data-grid";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import { find } from "lodash-es";
import { useWorkersContext } from "../../../context/WorkersContext";

type Props = {
	setModalEditDataWorker: Function;
	setModalDeleteWorker: Function;
	setWorkerIdForEdit: Function;
	setWorkerIdForDelete: Function;
};

export const useTableData = ({
	setWorkerIdForEdit,
	setModalEditDataWorker,
	setWorkerIdForDelete,
	setModalDeleteWorker,
}: Props) => {
	const {
		state: { workers },
	} = useWorkersContext();
	const {
		state: { workerTypes },
	} = useWorkerTypesContext();
	const columns: GridColDef[] = [
		{
			field: "workerId",
			headerName: " ",
			sortable: true,
			width: 0,
		},
		{
			field: "workerName",
			headerName: "Name",
			sortable: true,
			flex: 1,
		},
		{
			field: "workerTypeId",
			headerName: "Worker Type",
			sortable: true,
			flex: 1,
		},
		{
			field: "isActive",
			headerName: "Status",
			sortable: true,
			flex: 1,
		},
		{
			field: "Actions",
			renderCell: (params) => {
				return (
					<Grid
						container
						justifyContent="center"
						alignItems="center"
						spacing={1}
						style={{ padding: "0" }}
					>
						<Grid item md={6} xs={6} style={{ padding: "0", marginLeft: -25 }}>
							<Button
								fullWidth
								onClick={() => {
									(async () => {
										setWorkerIdForEdit(params.row.workerId);
										setModalEditDataWorker(true);
									})();
								}}
							>
								<EditIcon style={{ width: 16, height: 16 }} color="primary" />
							</Button>
						</Grid>
						<Grid item md={6} xs={6} style={{ padding: "0" }}>
							<Button
								fullWidth
								onClick={() => {
									(async () => {
										setWorkerIdForDelete(params.row.workerId);
										setModalDeleteWorker(true);
									})();
								}}
							>
								<DeleteIcon
									style={{ width: 16, height: 16 }}
									color="secondary"
								/>
							</Button>
						</Grid>
					</Grid>
				);
			},
			headerName: " ",
			sortable: false,
		},
	];

	const rows = workers.map(
		({ workerId, workerName, workerTypeId, isActive }) => {
			const type = find(workerTypes, ["workerTypeId", workerTypeId]);
			return {
				workerId: workerId,
				workerName: workerName,
				workerTypeId: type?.workerTypeName,
				isActive: isActive ? "Active" : "Inactive",
				id: workerId,
			};
		},
	);

	return { rows, columns };
};
